import { render, staticRenderFns } from "./PortalCliente.vue?vue&type=template&id=6937dd1c&scoped=true&"
import script from "./PortalCliente.vue?vue&type=script&lang=js&"
export * from "./PortalCliente.vue?vue&type=script&lang=js&"
import style0 from "./PortalCliente.vue?vue&type=style&index=0&id=6937dd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937dd1c",
  null
  
)

export default component.exports